/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Northern_AmericaInputs */

const bn_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উত্তর আমেরিকা`)
};

const de_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nordamerika`)
};

const el_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βόρεια Αμερική`)
};

const en_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Northern America`)
};

const es_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`América del Norte`)
};

const fr_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amérique du Nord septentrionale`)
};

const hi_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तरी अमेरिका`)
};

const hu_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Észak-Amerika`)
};

const id_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amerika Utara`)
};

const it_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nord America`)
};

const ja_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北アメリカ`)
};

const ko_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`북아메리카`)
};

const nl_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noord-Amerika`)
};

const pl_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ameryka Północna`)
};

const pt_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`América do Norte`)
};

const ru_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Северная Америка`)
};

const sv_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nordamerika`)
};

const tr_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuzey Amerika`)
};

const uk_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Північна Америка`)
};

const vi_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắc Mỹ`)
};

const zh_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北美洲`)
};

const zh_hant_geo_label_northern_america = /** @type {(inputs: Geo_Label_Northern_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北美洲`)
};

/**
* | output |
* | --- |
* | "Northern America" |
*
* @param {Geo_Label_Northern_AmericaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_northern_america = /** @type {((inputs?: Geo_Label_Northern_AmericaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Northern_AmericaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_northern_america(inputs)
	if (locale === "de") return de_geo_label_northern_america(inputs)
	if (locale === "el") return el_geo_label_northern_america(inputs)
	if (locale === "en") return en_geo_label_northern_america(inputs)
	if (locale === "es") return es_geo_label_northern_america(inputs)
	if (locale === "fr") return fr_geo_label_northern_america(inputs)
	if (locale === "hi") return hi_geo_label_northern_america(inputs)
	if (locale === "hu") return hu_geo_label_northern_america(inputs)
	if (locale === "id") return id_geo_label_northern_america(inputs)
	if (locale === "it") return it_geo_label_northern_america(inputs)
	if (locale === "ja") return ja_geo_label_northern_america(inputs)
	if (locale === "ko") return ko_geo_label_northern_america(inputs)
	if (locale === "nl") return nl_geo_label_northern_america(inputs)
	if (locale === "pl") return pl_geo_label_northern_america(inputs)
	if (locale === "pt") return pt_geo_label_northern_america(inputs)
	if (locale === "ru") return ru_geo_label_northern_america(inputs)
	if (locale === "sv") return sv_geo_label_northern_america(inputs)
	if (locale === "tr") return tr_geo_label_northern_america(inputs)
	if (locale === "uk") return uk_geo_label_northern_america(inputs)
	if (locale === "vi") return vi_geo_label_northern_america(inputs)
	if (locale === "zh") return zh_geo_label_northern_america(inputs)
	return zh_hant_geo_label_northern_america(inputs)
});